import useGetProjectUploads from '@/api/queries/project/useGetProjectUploads';
import { get as _get } from 'lodash-es';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import ProjectFileCard from './ProjectFileCard';
import { isMultipleFileSelection } from './utils/reactHookForm';

export interface IProps {
  name: string;
  formSection: any;
  formData: any;
}

const ProjectFileSelectionReadonly: FC<IProps> = (props) => {
  const { formSection, name, formData } = props;

  /**
   * Router
   */
  const { projectId } = useParams<{
    projectId: string;
  }>();

  /**
   * Queries
   */
  const { uploads } = useGetProjectUploads(projectId, undefined, {
    offset: 0,
    limit: 100,
  });

  const multiple = isMultipleFileSelection(formSection);
  const fieldName = multiple
    ? `${name}.projectFileIDs`
    : `${name}.projectFileID`;

  const value = _get(formData, fieldName);

  return (
    <ProjectFileCard.Wrapper>
      {uploads?.items
        .filter((file) => value?.includes(file.id))
        .map((file) => (
          <ProjectFileCard
            key={file.id}
            thumbnailUrl={file.thumbnailUrl || ''}
            fileName={file.fileName}
          />
        ))}
    </ProjectFileCard.Wrapper>
  );
};

export default ProjectFileSelectionReadonly;
